/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2025 - All Rights Reserved
###################################################################
*/

import { components } from './components/index';

const TaxesRatesBasisGroupSection = {
  components
};

export { TaxesRatesBasisGroupSection }